import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBuyThreeStepSet } from './ThreeStepBuyBox';

// Phone-only buy bar that slides up once the hero (and its buy box) has
// scrolled out of view, so Buy Now stays one tap away while reading.
export default function ThreeStepStickyBar() {
  const { t } = useTranslation();
  const { price, originalPrice, buyNow } = useBuyThreeStepSet();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById('three-step-hero');
      setShow(hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 700);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#141313]/95 backdrop-blur-md border-t border-white/10 px-4 py-3 flex items-center justify-between gap-3 transition-transform duration-300 ${show ? 'translate-y-0' : 'translate-y-full'}`}
      style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
    >
      <div className="min-w-0">
        <p className="text-[10.5px] tracking-[0.16em] uppercase text-[#C9A27A] truncate">{t('threeStep.buy.setLabel')}</p>
        <p className="flex items-baseline gap-2">
          <span className="font-serif font-bold text-white text-lg">{price}</span>
          <span className="text-[12px] text-white/35 line-through">{originalPrice}</span>
        </p>
      </div>
      <button
        onClick={buyNow}
        className="flex-shrink-0 px-6 py-3 bg-[#7B1113] text-white text-[12px] font-semibold tracking-[0.12em] uppercase rounded-full hover:bg-[#5C0D0F] active:scale-[0.98] transition-all cursor-pointer"
      >
        {t('common.buyNow')}
      </button>
    </div>
  );
}
